import { useState, useEffect } from 'react';
import { fetchPetStateData } from '../utils/api';

export function usePetState() {
  const [petState, setPetState] = useState({
    hunger: 50,
    energy: 50,
    happiness: 50,
    health: 50,
    currentState: 'good'
  });
  
  const [metrics, setMetrics] = useState({
    notes: {
      currentRate: 0,
      baseline: 0
    },
    zaps: {
      currentRate: 0,
      baseline: 0
    },
    moscowTime: {
      current: 0,
      baseline: 0
    }
  });
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    // Function to fetch pet state from API
    async function fetchPetState() {
      try {
        const data = await fetchPetStateData();
        
        setPetState(data.stats);
        setMetrics(data.metrics);
        
        // Handle connection status
        if (data.status) {
          setStatus(data.status);
        } else {
          setStatus({ connected: true, message: null });
        }
        
        setLoading(false);
      } catch (err) {
        console.error('Error fetching pet state:', err);
        setError('Failed to fetch pet state. Please try again later.');
        setLoading(false);
      }
    }

    fetchPetState();
    
    // Set up polling interval (every 30 seconds)
    const intervalId = setInterval(fetchPetState, 30000);
    
    // Clean up interval on unmount
    return () => clearInterval(intervalId);
  }, []);

  return { petState, metrics, loading, error, status };
} 